module.exports = __webpack_public_path__ + "img/banner1.8503b899.png";